// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_e27_vase_shade/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_e27_vase_shade: ModuleSchema = {
  "id": "core_e27_vase_shade",
  "uniqueId": "B3D_7ZE6Z",
  "createdAt": "2026-10-02T09:00:08.917Z",
  "updatedAt": "2026-10-30T10:31:13.342Z",
  "label": "E27 Vase",
  "description": "core_e27_vase_shade parametric 3D model",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_E27_VASE"
  ],
  "sliders": [
    {
      "key": "shadeH",
      "label": "Vase Height",
      "min": 80,
      "max": 260,
      "step": 2,
      "default": 170,
      "unit": "mm"
    },
    {
      "key": "shadeBotDia",
      "label": "Base Diameter (Ø)",
      "min": 70,
      "max": 160,
      "step": 1,
      "default": 95,
      "unit": "mm"
    },
    {
      "key": "shadeBellyDia",
      "label": "Belly Bulge Diameter (Ø)",
      "min": 80,
      "max": 200,
      "step": 1,
      "default": 140,
      "unit": "mm"
    },
    {
      "key": "shadeTopDia",
      "label": "Top Mouth Diameter (Ø)",
      "min": 50,
      "max": 160,
      "step": 1,
      "default": 85,
      "unit": "mm"
    },
    {
      "key": "bellyPos",
      "label": "Belly Bulge Position",
      "min": 0.25,
      "max": 0.55,
      "step": 0.01,
      "default": 0.38
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "vase_shade",
      "label": "E27 Vase Body (15 Layers / 3mm)",
      "default": "#f8fafc",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "e27_vase_shade_obj",
      "label": "E27 Vase Lampshade",
      "name": "E27 Vase Lampshade",
      "color": "#f8fafc",
      "assembled_z_offset": 0,
      "exploded_z_offset": 25,
      "parts": [
        {
          "id": "vase_shade",
          "label": "E27 Vase Body (15 Layers / 3mm)",
          "name": "E27 Vase Body (15 Layers / 3mm)",
          "groupId": 0,
          "colorKey": "vase_shade",
          "defaultColor": "#f8fafc",
          "assembled_z_offset": 0,
          "exploded_z_offset": 25,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": []
};
